import React, { Component } from 'react';
import { Form, Grid, Search } from 'semantic-ui-react';
import _ from 'lodash';

class SearchTableData extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            results: [],
            value: '',
            activeIndex: 0
        };
        this.handleSearchChange = this.handleSearchChange.bind(this);
    }

    handleSearchChange(e, { value }) {
        this.setState({ isLoading: true, value });

        setTimeout(() => {
            if (this.state.value.length < 1) {
                return this.setState({ isLoading: false, results: [], value: '' }, () => this.props.getResults(this.state.results));
            }

            const re = new RegExp(_.escapeRegExp(this.state.value), 'i');
            const isMatch = (result) => {
                let have = false;
                // eslint-disable-next-line no-return-assign
                return this.props.filterItem.filter((el) => (re.test(result[el]) ? have = true : false)).length !== 0;
            };

            this.setState({
                isLoading: false,
                results: _.filter(this.props.data, isMatch),
            });
            if (this.props.reset) this.setState({ value: '' });
            this.props.getResults(this.state.results);
        }, 300);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.resetValue !== this.props.resetValue) {
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState({ value: '' });
            this.props.getResults([]);
        }
    }

    render() {
        const { isLoading, value, results } = this.state;
        const { profMozilla, disabled } = this.props;
        return (profMozilla ?
            <Form>
                <Form.Field fluid>
                    <Search
                        disabled={disabled}
                        input={{ icon: 'search', iconPosition: 'left' }}
                        loading={isLoading}
                        onSearchChange={_.debounce(this.handleSearchChange, 500, {
                            leading: true,
                        })}
                        // results={results}
                        placeholder="Pretraga"
                        value={value}
                        open={results.length === 0 && value.length !== 0 && !isLoading}
                        noResultsMessage="Nema podataka."
                    />
                </Form.Field>
            </Form>
            :
            <Grid columns={1}>
                <Grid.Row>
                    <Grid.Column>
                        <Form>
                            <Form.Field>
                                <Search
                                    disabled={disabled}
                                    input={{ icon: 'search', iconPosition: 'left' }}
                                    loading={isLoading}
                                    onSearchChange={_.debounce(this.handleSearchChange, 500, {
                                        leading: true,
                                    })}
                                    placeholder="Pretraga"
                                    // results={results}
                                    value={value}
                                    open={results.length === 0 && value.length !== 0 && !isLoading}
                                    noResultsMessage="Nema podataka."
                                />
                            </Form.Field>
                        </Form>
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        );
    }
}

export default SearchTableData;




// WEBPACK FOOTER //
// ./src/views/util/SearchTableData.js